import React, { useState, useEffect, useRef } from 'react';
import CovidRiskCheckerService from 'services/covid-risk-checker.service';
import AuthService from 'services/auth.service';
import { Form, Modal, Button } from "react-bootstrap";
import CovidRiskCheckerSubmitConfirmModal from "./CovidRiskCheckerSubmitConfirmModal";
import CovidRiskCheckerQuestionnaire from "./CovidRiskCheckerQuestionnaire";
import Select from 'react-select';

function CovidRiskChecker({chat}) {
  const isCovidCancelled = useRef(false);
  const [certified, setCertified] = useState(chat?.covid?.covid_symptoms.length > 0); 
  const [symptoms, setSymptoms] = useState(chat.covid?.covid_symptoms);
  const [noSymptoms, setNoSymptoms] = useState(!chat.covid?.enabled);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSymptomsConfirm, setShowSymptomsConfirm] = useState(false);
  const questionnaire = chat.covid?.quizs || [];

  const options = chat.covid?.symptom_options.map((value) => {
    return { value: value, label: value }
  });

  const CovidConfirmationModal = () => {
    return (
      <Modal show={showConfirmation} onHide={() => {setShowConfirmation(false)}} backdrop="static" keyboard={false}>
        <Modal.Body>
          By checking <b>"No symptoms reported for this consultation"</b>, you are indicating that the patient has no covid symptom. Do note that this action is irreversible. Please confirm.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setShowConfirmation(false)}}>Cancel</Button>
          <Button variant="danger" onClick={confirmnoSymptoms}>Yes, Confirm</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  useEffect(() => {
    if(!certified){
      const params = {
        has_covid_symptoms: !noSymptoms
      }
      CovidRiskCheckerService.toggleCovid(chat.id, params).then(
        (data) => {},
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
    return () => {
      isCovidCancelled.current = true;
    };
  }, [noSymptoms]); // eslint-disable-line

  const confirmnoSymptoms = () => {
    setNoSymptoms(true);
    setShowConfirmation(false);
  }  

  const handleSetNoSymptoms = (e) => {
    if(e.target.checked){
      setShowConfirmation(true);
    }else{
      setNoSymptoms(false);
    }
  }

  const onSymptomsChange = (e) => {
    setSymptoms(e.map((val) => val.value));
  }

  const symptomsField = () => {
    if(certified){
      return (
        <>
          <div className="section-title">SYMPTOMS</div>
          <div className="d-flex symptom-row align-items-baseline">
              <label className="col-4 field-label">Please describe the patient's symptoms</label>
              <div className="col-8">
                <ul>
                  {
                    symptoms.map((symptom, index) => {
                      return <li key={`symptom-${index}`}>{symptom}</li>
                    })
                  }
                </ul>
              </div>
          </div>
        </>
      )
    }else{
      return (
        <>
          <div className="section-title">SYMPTOMS</div>
          <div className="d-flex symptom-row">
              <label className="col-4 field-label">Please describe the patient's symptoms</label>
              <div className="col-8">
                <Select className="symptoms-field react-select" options={options} onChange={(val) => onSymptomsChange(val)} placeholder="Select Symptoms" isMulti/>
              </div>
          </div>
        </>
      );
    }
  }

  const symptomsConfirm = () => {
    if(symptoms.length > 0){
      setShowSymptomsConfirm(true);
    }else{
      alert("Please select a symptom before submitting.");
    }
  }

  return (
    <div className="covid-19-risk-checker">
      <h6 className="p-2">Covid-19 Risk Checker</h6>
      {certified ? 
        <>
          <CovidRiskCheckerQuestionnaire questionnaire={questionnaire} />
          {symptomsField()}
        </> : (
        <>
          <Form.Check inline>
            <Form.Check.Input 
              id="noCovidSymptoms" 
              type="checkbox" 
              checked={noSymptoms}
              onChange={(e) => {handleSetNoSymptoms(e)}} 
              disabled={noSymptoms}/>
            <Form.Check.Label htmlFor="noCovidSymptoms">No symptoms reported for this consultation</Form.Check.Label>
          </Form.Check>
          {!noSymptoms && 
            <>
              <CovidRiskCheckerQuestionnaire questionnaire={questionnaire} />
              {symptomsField()}
              <div className="d-flex justify-content-end mt-8">
                <div><button className="btn save-symptoms-btn" onClick={() => symptomsConfirm()}>Save & Send</button></div>
              </div>
            </>
          }
          <CovidConfirmationModal />
          <CovidRiskCheckerSubmitConfirmModal setShowSymptomsConfirm={setShowSymptomsConfirm} showSymptomsConfirm={showSymptomsConfirm} symptoms={symptoms} setCertified={setCertified} chatId={chat.id}/>
        </>
      )}
    </div>
  )
}

export default CovidRiskChecker;